import { render } from "./formItem.vue?vue&type=template&id=d1064c82&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"

import "./formItem.vue?vue&type=style&index=0&id=d1064c82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1064c82"]])

export default __exports__